import * as React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

import TextButton from '@/components/elements/Button/TextButton';
import { Term } from '@/lib/microcms/model';

import { Headline } from '../../style';
import {
  ButtonWrapper,
  Container,
  Initial,
  ListItem,
  TermList,
  Wrapper,
} from './style';

interface TermListTemplateProps {
  terms: Term[];
  initial: string;
  loading: boolean;
}

const TermListTemplate: React.FC<TermListTemplateProps> = ({
  terms,
  initial,
  loading,
}) => {
  return (
    <Container>
      <Headline>競輪用語集</Headline>
      <Wrapper>
        <Initial>{initial}</Initial>
        <TermList>
          {loading ? (
            <>
              {[...Array(5)].fill('').map((_, i) => (
                <li key={`skeleton-${i}`}>
                  <Skeleton height="25px" />
                </li>
              ))}
            </>
          ) : (
            <>
              {terms.map(term => (
                <Link
                  to={`/glossary/${initial}/${term.termName}`}
                  key={term.termName}
                >
                  <ListItem>
                    {term.termName}（{term.hiragana}）
                  </ListItem>
                </Link>
              ))}
            </>
          )}
        </TermList>
      </Wrapper>
      <ButtonWrapper>
        <Link to="/glossary">
          <TextButton size="s" hoverEffect="highlight">
            競輪用語集TOPに戻る
          </TextButton>
        </Link>
      </ButtonWrapper>
    </Container>
  );
};

export default TermListTemplate;
